export const TAB_PATHS = {
	map: '/map',
	activities: '/activities',
	create: '/create',
	chats: '/chats',
	profile: '/profile',
} as const;

export type Tab = keyof typeof TAB_PATHS;

/** Event detail (S3, T-205). */
export const EVENT_PATH = '/events/:id';

/** Manage activity (S8, organizer). */
export const EVENT_MANAGE_PATH = '/events/:id/manage';

export function eventManagePath(id: string): string {
	return `/events/${encodeURIComponent(id)}/manage`;
}

/** Applications & participants (S9, organizer). */
export const EVENT_APPLICATIONS_PATH = '/events/:id/applications';

export function eventApplicationsPath(id: string): string {
	return `/events/${encodeURIComponent(id)}/applications`;
}

export function eventPath(id: string): string {
	return `/events/${encodeURIComponent(id)}`;
}

/** The event screen with the review sheet open (S17; `review_<eventId>` from the bot, T-902). */
export function eventReviewPath(id: string): string {
	return `${eventPath(id)}?review=1`;
}

/** The event screen on its Chat tab (S11; organizer and accepted participants). */
export function eventChatPath(id: string): string {
	return `${eventPath(id)}?tab=chat`;
}

/** Public profile (S13). */
export const USER_PATH = '/users/:id';

export function userPath(id: string): string {
	return `/users/${encodeURIComponent(id)}`;
}

/** Edit own profile (S14). */
export const PROFILE_EDIT_PATH = '/profile/edit';

/** Notification center and its settings (S15), from the own profile. */
export const NOTIFICATIONS_PATH = '/profile/notifications';
export const NOTIFICATION_SETTINGS_PATH = '/profile/notifications/settings';

/** People you blocked (S16), from the own profile. */
export const BLOCKED_PATH = '/profile/blocks';

/** Activities → Мої on a given tab (profile shortcuts). */
export function activitiesPath(tab: 'upcoming' | 'created' | 'past' | 'saved'): string {
	return `${TAB_PATHS.activities}?view=mine&tab=${tab}`;
}

/** Tab roots hide the Telegram BackButton; every deeper screen shows it. */
export function isTabRoot(pathname: string): boolean {
	return (Object.values(TAB_PATHS) as string[]).includes(pathname);
}
